import { useEffect, useState } from "react";
import { Icon } from "../../../../components/icons/Icon";
import { IconMap } from "../icons/IconMap";
// import { tracks } from "../icons/Transportation";

/**
 * If item is "tracks", we render the bordered circle with an <img>.
 * Otherwise we render your mask-based icon with background color class.
 */
export default function SegmentPath({ first, last, iconInfo }) {
  const [viewportWidth, setViewportWidth] = useState(null);

  // set doc title
  useEffect(() => {
    const viewportW = window.innerWidth;
    setViewportWidth(viewportW);
  }, [viewportWidth]);

  return (
    <div className="segment-column-path">
      {/* prepend path */}
      <div
        className={`segment-path-line prepend${first ? " hidden" : ""}`}
      ></div>

      <div className="icon">
        {iconInfo?.isTracks ? (
          <Icon
            icon={IconMap[iconInfo?.segmentSubType || "default"]}
            size={viewportWidth <= 500 ? 20 : 25}
            width={viewportWidth <= 500 ? 20 : 25}
            height={viewportWidth <= 500 ? 20 : 25}
            color="var(--surface)"
          />
        ) : (
          // tracks icon
          // <div className="svg segment-path-icon round border">
          //   <img
          //     src="../../assets/images/tracks.svg"
          //     width="24"
          //     height="24"
          //     alt="track"
          //   />
          // </div>
          // css icons
          <div
            className={`svg round segment-path-icon ${
              iconInfo?.bgClass || "neutral"
            }`}
          >
            <Icon
              icon={IconMap[iconInfo?.segmentSubType || "default"]}
              size={viewportWidth <= 500 ? 20 : 25}
              width={viewportWidth <= 500 ? 20 : 25}
              height={viewportWidth <= 500 ? 20 : 25}
              color="var(--surface)"
            />
            {/* <div className={iconInfo?.maskClass || "svg-icon-mask-clock"}></div> */}
          </div>
        )}
      </div>
      {/* appending path */}
      <div className={`segment-path-line append${last ? " hidden" : ""}`}></div>
    </div>
  );
}
